import { useState } from "react";
import { motion } from "framer-motion";
import { Loader2, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import { sendContact } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const Contact = () => {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", pharmacy: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await sendContact(form);
      toast.success(t.contact.sent);
      setForm({ name: "", pharmacy: "", email: "", phone: "", message: "" });
    } catch {
      toast.error(t.contact.error);
    }
    setLoading(false);
  };

  return (
    <section id="contact" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <motion.h2
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-heading text-4xl font-bold leading-tight tracking-tight text-primary lg:text-5xl">
            {t.contact.title}
          </motion.h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-muted-foreground">{t.contact.sub}</p>
          <div className="mt-10 flex items-center gap-2 font-heading text-2xl font-semibold text-secondary">
            aponiqo@outlook.com <ArrowUpRight className="h-5 w-5 text-accent" />
          </div>
        </div>

        <form onSubmit={submit} className="rounded-2xl border border-border bg-card p-8 lg:col-span-6 lg:col-start-7" data-testid="contact-form">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Input required placeholder={t.contact.name} value={form.name} onChange={set("name")} data-testid="contact-name" />
            <Input required placeholder={t.contact.pharmacy} value={form.pharmacy} onChange={set("pharmacy")} data-testid="contact-pharmacy" />
            <Input required type="email" placeholder={t.contact.email} value={form.email} onChange={set("email")} data-testid="contact-email" />
            <Input placeholder={t.contact.phone} value={form.phone} onChange={set("phone")} data-testid="contact-phone" />
          </div>
          <Textarea required placeholder={t.contact.message} value={form.message} onChange={set("message")} rows={5} className="mt-4" data-testid="contact-message" />
          <button type="submit" disabled={loading} data-testid="contact-submit"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-accent py-4 font-semibold text-white transition-transform hover:bg-secondary active:scale-95 disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t.contact.send}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
